import { render, staticRenderFns } from "./ztInputFile.vue?vue&type=template&id=31ab915f&"
import script from "./ztInputFile.vue?vue&type=script&lang=js&"
export * from "./ztInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports